import { useState, useEffect, useRef } from "react";
import {
    getMqttClient,
    subscribeTopic,
    getMqttStatus,
    onMqttStatus,
} from "../services/mqttClient";

const parsePayload = (message) => {
    let payload = message?.toString?.();
    try { payload = JSON.parse(payload); } catch { }
    return payload;
};

const useMqttSubscription = (topic, onMessage) => {
    const [connectionStatus, setConnectionStatus] = useState(getMqttStatus());
    const [subscribed, setSubscribed] = useState(true);
    const cbRef = useRef(onMessage);

    useEffect(() => { cbRef.current = onMessage; }, [onMessage]);

    // Estado de la conexión compartida
    useEffect(() => onMqttStatus(setConnectionStatus), []);

    // Suscripción al topic (la conexión no se corta al desmontar)
    useEffect(() => {
        if (!topic || !subscribed) return;
        return subscribeTopic(topic, (_topic, message) => {
            try {
                cbRef.current?.(parsePayload(message));
            } catch (e) {
                console.error("MQTT handler error:", e);
            }
        });
    }, [topic, subscribed]);

    const pause = () => setSubscribed(false);
    const resume = () => setSubscribed(true);
    const toggle = () => setSubscribed((s) => !s);

    return {
        client: getMqttClient(),
        connectionStatus,
        subscribed,
        pause,
        resume,
        toggle,
    };
};

export default useMqttSubscription;